// chakra imports
import { 
  Avatar,
   Flex,
   Grid,
   Box,
    Text,
     useColorModeValue,
  useColorMode,
  useDisclosure,
 Button,
  Modal,
  ModalBody,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalFooter, } from "@chakra-ui/react";
import { ClockIcon } from "components/Icons/Icons";
import React from "react";
import NiceButton from "components/NiceButton/NiceButton.js";

export function ItemContent(props) {
  const { colorMode } = useColorMode();
  const navbarIcon = useColorModeValue("gray.500", "gray.500");
  const { isOpen, onOpen, onClose } = useDisclosure()
  const notificationColor = useColorModeValue("gray.700", "white");
  return (
    <Flex onClick={onOpen}
    flexDirection='row'
    >
    
      <Avatar
        name={props.aName}
        src={props.aSrc}
        borderRadius="12px"
        me="16px"
      />
      <Flex flexDirection="column">
        <Text fontWeight="bold" fontSize="xs" color={notificationColor}>
          {props.info}
        </Text>
        <Text fontSize="xs" mb="5px">
          {props.boldInfo}
        </Text>
        <Flex alignItems="center">
          <ClockIcon color={navbarIcon} w="13px" h="13px" me="3px" />
          <Text fontSize="xs" lineHeight="100%" color={navbarIcon}>
            {props.time}
          </Text>
        </Flex>
      </Flex>
      <Modal
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader textAlign="center" fontSize="md">{props.info}</ModalHeader>
          <ModalCloseButton />
          <ModalBody fontSize="xs">
          
            <Text fontSize="sm"  style={{ whiteSpace: "pre-line" }} textAlign={"justify"}>
            {props.text}
          </Text>
          </ModalBody>
          <ModalFooter>
            <Button fontSize='xs' onClick={onClose}>بستن</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}
